import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator'
import PopupModal from '@/components/common/Modal/PopupModal.vue'
import ProfilePhoto from '@/components/common/ProfilePhoto.vue'
import { cache } from '@/util';
import { mapGetters } from 'vuex';
import * as types from '@workflow/store/types'
import orgmapApi from '@orgmap/api'

@Component({
    components: { PopupModal, ProfilePhoto },
})
export default class DrafterViewModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: Object }) item!: any

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    avatar = {
        url: '',
        loading: false,
    };

    drafter: any = {}
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    call(phoneNumber: string) {
        let Param: any = {}
        Param.Type = 'Call'
        Param.PhoneNumber = phoneNumber
        this.invokeCSCode(JSON.stringify(Param))
    }

    async invokeCSCode(data: any) {
        try {
            if ((window as any).invokeCSharpAction) {
                (window as any).invokeCSharpAction(data)
            } else {
                var obj = JSON.parse(data);
                const link = document.createElement('a')
                link.href = 'tel:' + obj.PhoneNumber
                link.click();
                (process as any).nextTick(() => link.remove())
            }
        } catch (err) {
            await(window as any).alertAsync(err);
        }
    }

    getImage(email?: string) {
        if (email && email.indexOf('/') == -1) {
            this.avatar.loading = true
            cache.avatar.get(email).then((url: string) => {
                this.avatar.url = url
                this.avatar.loading = false
            });
        }
    }

    error(e: Event) {
        var elem = e.srcElement as HTMLImageElement
        elem.src = '/cm/gres/v1/img/ghost_loading.png'
    }

    errorGhost(e: Event) {
        var elem = e.srcElement as HTMLImageElement
        elem.src = '/cm/gres/faux/images/ghost.png'
    }

    async writeEmail() {
        if (this.drafter.email) {
            this.$router.push({
                path: '/mail/write',
                query: { id: '', type: 'draft', uid: this.drafter.email },
            });
        } else {
            await(window as any).alertAsync(this.$t('M_Contact_NoEmail').toString());
        }
    }

    @Watch('item')
    onChangedDrafter() {
        if (this.item) {
            this.drafter = this.item;
            this.getImage(this.drafter.email);
        }
    }
}
